import { render, staticRenderFns } from "./flash-transition.vue?vue&type=template&id=21dae03e"
import script from "./flash-transition.vue?vue&type=script&lang=js"
export * from "./flash-transition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports